<app-ace-cascading-select
  [loading]="loading"
  [items]="levels"
  [appendTo]="appendTo"
  [formControl]="formControl"
  [childPropertyNames]="['zones']"
  [compareWith]="compareFunctions"
  [bindLabels]="['level_name', 'zone_name.zone_name']"
  [placeHolders]="[placeHolders.level | messageTranslate, placeHolders.zone | messageTranslate]"
  [numRequired]="zoneOptional ? 1 : 2"
  [multiSelect]="multiSelect"
  [dependentDisabledMessages]="dependentDisabledMessages"
  (itemsInitialised)="onItemsInitialised()"
  (touched)="onLevelZoneTouched()"/>
